export const Detail=[
   {
      id: 0,
      image: "1.jpeg",
      pitch: [184.41,165],
      yaw: [154.76,210],
      idNav:[1,2],
      yawscreen: 10,
      pitchscreen: 10,
      },
   {
       id: 1,
       image: "2.jpeg",
       pitch: [190.41,155],
       yaw: [200.76,140],
       idNav:[0,2],
       yawscreen: 10,
       pitchscreen: 10,
    },
    {
       id: 2,
       image: "3.jpeg",
       pitch: [190.41,205],
       yaw: [390.76,115],
       idNav:[0,1],
       yawscreen: 250,
       pitchscreen: 1,
    }
];